import React from "react";



const Pictures = () => {
    return(
        <div className="image-gallery">
            <div className="milk">
                <img src="/images/mobile/image-gallery-milkbottles.jpg" alt="milk" />
            </div>
            <div className="oranje">
                <img src="/images/mobile/image-gallery-orange.jpg" alt="orange" />
            </div>
            <div className="cone">
                <img src="/images/mobile/image-gallery-cone.jpg" alt="cone"/>
            </div>
            <div className="sugar">
                <img src="/images/mobile/image-gallery-sugar-cubes.jpg" alt="sugar" />
            </div> 
        </div>
        )
}

export default Pictures